import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/2.png'
import _imports_1 from '../../../assets/image/newhome/all.png'
import _imports_2 from '../../../assets/image/newhome/all2.png'
import _imports_3 from '../../../assets/image/newhome/jiantou.png'
import _imports_4 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-7433bcaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-7433bcaf><img src=\"" + _imports_0 + "\" alt=\"\" data-v-7433bcaf><div class=\"text\" data-v-7433bcaf>工业自动化知识学习区</div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-7433bcaf></div><div class=\"title1\" data-v-7433bcaf>设计学习者、爱好者的知识加油站</div>", 2)
const _hoisted_4 = { class: "good-title container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "recommend"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "recommend"
}
const _hoisted_8 = { class: "p" }
const _hoisted_9 = {
  key: 2,
  src: _imports_3,
  alt: "",
  class: "jiantou"
}
const _hoisted_10 = { class: "good-list container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pic" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pic-img-3d",
  src: _imports_4
}, null, -1))
const _hoisted_15 = { class: "txt" }
const _hoisted_16 = {
  key: 0,
  class: "attr nowrap"
}
const _hoisted_17 = { class: "click-num" }
const _hoisted_18 = { class: "left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["title-item", { active: _ctx.isActive == index }]),
          key: index,
          onClick: ($event: any) => (_ctx.active(index))
        }, [
          (index == 0 && _ctx.isActive == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.isActive != 0 && index == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1),
          (index == _ctx.isActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true)
        ], 10, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList.data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "goods-info",
          onClick: ($event: any) => (_ctx.goto(item.id))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "pic-img",
              src: item.old_avatar
            }, null, 8, _hoisted_13),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass([{ NoAttr: !item.desc }, "title-two nowrap"])
            }, _toDisplayString(item.name), 3),
            (item.desc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(item.desc), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(item.browse) + "次浏览", 1)
            ])
          ])
        ], 8, _hoisted_11))
      }), 256)),
      _createElementVNode("div", {
        class: "more",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goClass()))
      }, "查看更多")
    ])
  ]))
}